"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var app_1 = require("app");
var GoogleAnalytics_1 = require("../../Components/Header/GoogleAnalytics");
require("./style.scss");
var init = (function () {
    var $element = $("#searchInput");
    var searchIn = ".tile__text-title, .tile__text-details_item, .paragraph-link a";
    var googleAnalyticsSettings = $(".header__mobile-menu-wrapper").data("google-analytics");
    if (!$element.length) {
        return;
    }
    function inputChanged() {
        var value = $element.val().toLowerCase();
        var $categoryItems = $(".tile");
        $categoryItems.filter(function () {
            var $el = $(this);
            var searchBy = $el.find(searchIn).text();
            var $groupItem = $el.closest(".expand-collapse-item");
            var $visibleItems;
            //collapse group on start searching
            if ($groupItem.hasClass("expand-collapse-item--opened")) {
                $groupItem.find(".item-title").click();
            }
            //filter items
            $el.toggle(searchBy.toLowerCase().indexOf(value) > -1);
            $visibleItems = $groupItem.find(".tile").not('[style*="display: none"]');
            // calculate group items and hide group with 0 items
            $groupItem.find(".item-count").text($visibleItems.length);
            $groupItem.toggle($visibleItems.length > 0);
            // hide line after last group element
            $visibleItems.not(":last-child").css("border-bottom-width", "1px");
            $visibleItems.last().css("border-bottom-width", "0");
        });
        // open single category
        var $item = $(".expand-collapse-item").not('[style*="display: none"]');
        if ($item.length === 1 && !$item.hasClass("expand-collapse-item--opened")) {
            $item.find(".item-title").click();
        }
    }
    ;
    window.addEventListener('CookieInformationConsentGiven', function (event) {
        event = __assign(__assign({}, event), { origin: event.target.location.origin });
        // For security always check origin when using eventlisteners
        if (event.origin !== googleAnalyticsSettings.applicationUrl) {
            return;
        }
        // Get user cookie acceptance from cookieinformation
        var acceptance = (0, GoogleAnalytics_1.getCookieCategoriesAcceptance)();
        // If the user has accepted statistic cookies we can continue
        if (acceptance && acceptance.statistic) {
            (function () {
                var searchInput = document.getElementById('searchInput');
                if (searchInput) {
                    searchInput.addEventListener('input', (0, app_1.debounce)(inputHandler, 800, false));
                }
            })();
        }
    }, false);
    // Your original event listener function
    var inputHandler = function (event) {
        var searchInput = document.getElementById('searchInput');
        var searchValue = searchInput.value.toLowerCase();
        var categoryElements = document.getElementsByClassName('page-heading rte');
        var categoryName = "";
        if (categoryElements.length > 0) {
            var categoryElement = categoryElements[0];
            categoryName = categoryElement.innerText;
        }
        // Function to initialze Google Analytics
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'search',
            'search_term': searchValue,
            'search_category': categoryName
        });
    };
    $element.on("keyup", (0, app_1.throttle)(inputChanged.bind(_this), 700));
})();
